/**
 * @generated SignedSource<<5981414a205fe3b2d97b4579b8dee564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionTextComponent$data = {
  readonly id: string;
  readonly textValue: string | null;
  readonly " $fragmentType": "TaskExecutionTextComponent";
};
export type TaskExecutionTextComponent$key = {
  readonly " $data"?: TaskExecutionTextComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionTextComponent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionTextComponent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionText",
  "abstractKey": null
};

(node as any).hash = "dca2f89641c186bb5372102d869371fa";

export default node;
